import { OrderCategory } from "../../../api/endpoints/Order";
import { map, padStart } from "lodash";
import React, { Fragment } from "react";
import { TOrderProductData } from "../../../api/endpoints/OrderProduct";

const TimeStep = (props: {
  values: TOrderProductData<OrderCategory.REALTIME>['time_step']
}) => {
  const { values } = props;
  const parsed = map(values,
    value => `${value.step}h (${padStart(value.time.toString(), 2, '0')})`
  );

  return (
    <Fragment>
      {
        parsed.join(', ')
      }
    </Fragment>
  );
};

export default TimeStep;
